export const ADD_MMR_VALUE = 'ADD_MMR_VALUE';
export const REMOVE_MMR_VALUE = 'REMOVE_MMR_VALUE';
